import { render, staticRenderFns } from "./ChatNote.vue?vue&type=template&id=c5641562&scoped=true"
import script from "./ChatNote.vue?vue&type=script&lang=js"
export * from "./ChatNote.vue?vue&type=script&lang=js"
import style0 from "./ChatNote.vue?vue&type=style&index=0&id=c5641562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5641562",
  null
  
)

export default component.exports